import { render, staticRenderFns } from "./yxbank.vue?vue&type=template&id=7ae2beb7&scoped=true&"
import script from "./yxbank.vue?vue&type=script&lang=js&"
export * from "./yxbank.vue?vue&type=script&lang=js&"
import style0 from "./yxbank.vue?vue&type=style&index=0&id=7ae2beb7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae2beb7",
  null
  
)

export default component.exports